<div class="container">
  <div fxLayout="row">
    <label>{{ 'campaign.item.reschedule_form.date_label' | translate }}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start end" fxLayoutAlign.xs="start" fxFlexFill
    fxLayoutGap="10px" fxLayoutGap.xs="0">
    <div fxFlex>
      <mat-form-field class="full-width">
        <mat-label>{{ 'public.date'|translate }}</mat-label>
        <input matInput [formControl]="startDateCtrl" [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div fxFlex>
      <flex-time-picker class="full-width" [formControl]="startTimeCtrl"
        placeholder="{{ 'campaign.hour_start' | translate }}">
      </flex-time-picker>
    </div>
  </div>
</div>
